export const formatDateDDMMYYYY = (input) => {
    if (!input) return "";

    // Si viene como "YYYY-MM-DD" o "YYYY-MM-DDTHH:mm:ss..."
    if (typeof input === "string") {
        const m = input.match(/^(\d{4})-(\d{2})-(\d{2})/);
        if (m) return `${m[3]}-${m[2]}-${m[1]}`;
    }

    const d = input instanceof Date ? input : new Date(input);
    if (Number.isNaN(d.getTime())) return "";

    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const yyyy = String(d.getFullYear());

    return `${dd}-${mm}-${yyyy}`;
};

export const getLocalDateString = (date = new Date()) => {
    const d = date instanceof Date ? date : new Date(date);
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
};